<template>
  <div>
    <!-- Added by Aung
            For Influencer approved view from email link
         -->
<v-layout justify-center>
    <v-container transition="slide-x-transition">
      <v-alert :value="showConnectionError" type="error">Couldn't Connect to Post Service! Please Comeback Later!</v-alert>
      <v-row transition="slide-x-transition" v-if="approvedPost.influencer">
        <v-col cols="12" sm="12" lg="4" md="4">
          <v-hover>
            <!-- new card -->
            <v-card class="mx-auto my-12" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
              <v-list-item>
                <v-list-item-avatar color="grey">
                  <img :src="paserImageUrl(approvedPost.influencer.profilePicture)" alt="avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 ma-0">{{ approvedPost.mainPost.campaignName }}</v-list-item-title>
                  <v-list-item-subtitle class="caption font-italic">
                    By
                    <a :href="'https://instagram.com/' + approvedPost.influencer.username" target="_blank"
                      >@{{ approvedPost.influencer.username }}</a
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-img
                v-if="!approvedPost.mainPost.images[0]"
                src="/static/img/upload-post-photo.png"
                height="300px"
                @click="viewDetailPost(approvedPost.mainPost)"
                style="cursor: pointer"
              ></v-img>
              <v-img
                v-if="approvedPost.mainPost.images[0] && !approvedPost.mainPost.images[0].isvideo"
                :src="approvedPost.mainPost.images[0].url"
                height="300px"
                @click="viewDetailPost(approvedPost.mainPost)"
                style="cursor: pointer"
              ></v-img>
              <video
                v-if="approvedPost.mainPost.images[0] && approvedPost.mainPost.images[0].isvideo"
                height="300px"
                width="100%"
                @click="viewDetailPost(approvedPost.mainPost)"
                style="cursor: pointer"
              >
                <source :src="approvedPost.mainPost.images[0].url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              <v-card-text></v-card-text>

              <v-card-actions>
                <v-chip
                  v-for="label in approvedPost.mainPost.labels"
                  :key="label.text"
                  class="ma-1"
                  small
                  :color="label.color"
                  :outlined="label.outlined"
                  :dark="label.dark"
                  @click="exec(label.action, approvedPost.mainPost)"
                >
                  {{ label.text }}
                  <v-icon right>{{ label.icon }}</v-icon>
                </v-chip>
                <v-spacer></v-spacer>
                    <!-- <v-menu top right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                          v-for="(menuItem, i) in menuOptions"
                          :key="i"
                          @click="actionPostBy(menuItem.action, approvedPost.mainPost)"
                        >
                          <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                          <v-list-item-action>
                            <v-icon>{{menuItem.icon}}</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-menu> -->
              </v-card-actions>
            </v-card>
            <!-- new card -->
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
</v-layout>
    <view-post-modal
      v-model="viewPostDialog"
      :post="viewPostData"
      :csActions="showCsEditAction"
      :proposeDateActions="showProposeDateAction"
      :saleActions="showSaleAction"
      :clientActions="showClientEditAction"
      :influencerActions="showInfluencerEditAction"
      :cs_inf_chatbox="show_cs_inf_chatbox"
      :postAbuseHistory="false"
      :postReviewApproved="false"
      :postHistory="showPostHistory"
      :userObj="user"
      :value="viewPostDialog"
      @csApproved="csApproveFromView"
      @saleReleased="saleReleasePost"
      @editPost="editPostFromView"
      @mainPostChanged="reloadPostView"
    />
  </div>
</template>
<script>
import config from '@/config';
import moment from 'moment';
import PostAPI from './postApi';
import postConfig from './postConfig';
import ViewPostModal from './ViewPostModal.vue';
import { platformDisplayName } from '@/utils/platformDisplay';
export default {
  name: 'postdetail',
  components: {
    ViewPostModal
  },
  data() {
    return {
      loading: false,
      showConnectionError: false,
      approvedPost: {},
      viewPostDialog: false,
      showDetailModalFromRoute: false,
      showProposeDateAction: false
    }
  },
  methods: {
    getApprovedPost(id) {
      // let status = this.postStatus;
      this.loading = true;
      PostAPI.getPostById(id)
      .then(resp => {
        this.loading = false;
        this.showConfirmDate = false;
        this.showConnectionError = false;
        resp.mainPost.labels = this.getPostLabels(resp.mainPost);
        this.approvedPost = resp;
        if (this.$route.query.confirmDate && !this.showDetailModalFromRoute) {
          this.showDetailModalFromRoute = true
          this.viewDetailPost(resp.mainPost)
        }
      })
      .catch(err => {
        this.showConnectionError = true;
        this.loading = false;
        console.log('Error', err);
      });
      this.filterMenuOptions();
    },
    paserImageUrl(url) {
      if (url) {
        var newUrl = url
          .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
          .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    getPostLabels(post) {
      let labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.AD_STRATEGIST) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }

      if (
        !post.waiting_release &&
        this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING &&
        this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW
      ) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          labels.push({
            text: 'Abuse Reported',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'deep-orange',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: 'New',
            outlined: true,
            dark: false,
            icon: 'new_releases',
            color: 'primary',
            action: 'viewDetailPost'
          });
        }
      }

      if (
        post.comments &&
        this.postStatus < this.postStatusConfig.APPROVE &&
        (this.currentUserRole === this.userRoles.INFLUENCER ||
        this.currentUserRole === this.userRoles.AD_STRATEGIST ||
        this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)
      ) {
        labels.push({
          text: `(${this.commentsInfo(post.comments)}) Comments`,
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: `${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: `Today - ${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && this.postStatus === this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: platformDisplayName(post.type),
          color: 'primary',
          action: 'viewDetailPost'
        })
      }
      return labels;
    },
    actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    reloadPostView(postData) {
      this.viewDetailPost(postData);
    },
    viewDetailPost(post) {
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if ((post.status === config.postStatus.CLIENT_PENDING || post.status === config.postStatus.APPROVE) &&
      (this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH)) {
        this.showProposeDateAction = true;
      } else {
        this.showProposeDateAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === config.postStatus.CLIENT_PENDING && this.currentUserRole === config.userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if (
        (this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.INFLUENCER) &&
        post.campaignID
      ) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id);
      this.viewPostDialog = true;
      this.getApprovedPost(post._id);
    },
    fetchPost(postId, returnData) {
      PostAPI.getPostById(postId)
        .then(post => {
          this.viewPostData = post;
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
        });
    },
    formatDate(date, format = 'll') {
      return moment(date).format(format);
    },
    checkAfter(date) {
      return moment(this.currentDate).isAfter(date);
    },
    checkSame(date) {
      return moment(this.currentDate).isSame(date);
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions() {
      let options = postConfig.menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(option => this.buttonShow(option.action));
      }
    },
    // filterTableActions() {
    //   let options = postConfig.tableActions;
    //   if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
    //     this.tableActions = options;
    //   } else {
    //     this.tableActions = options.filter(option => this.buttonShow(option.action));
    //   }
    //   this.tableActions = this.tableActions.map(item => {
    //     item.disabled = true;
    //     return item;
    //   });
    // },
    submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    }
  },
  computed: {
    user: function() {
      return this.$store.state.user;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function() {
      return this.$route.meta.postStatus;
    },
    userRoles: function() {
      return config.userRoles;
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    currentDate: function() {
      return moment().format('ll');
    }
  },
  mounted() {
    this.getApprovedPost(this.$route.params.postId)
  }
};
</script>



// WEBPACK FOOTER //
// PostDetail.vue?0b797ad5